import { render, staticRenderFns } from "./InstitutionsList.vue?vue&type=template&id=67e08956&"
import script from "./InstitutionsList.vue?vue&type=script&lang=js&"
export * from "./InstitutionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports